import { Box } from '@material-ui/core'
import { ElementWithChildren } from 'types'
import { useUser } from './UserProvider'

export const AppRerenderer = ({ children }: ElementWithChildren): JSX.Element => {
  const { activeGame, user } = useUser()

  return <Box key={activeGame.name + user.cardmarketUsername}>{children}</Box>
}
